/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

export type GetUsersWithAnyOfPermissionsPermissionIdsItem = typeof GetUsersWithAnyOfPermissionsPermissionIdsItem[keyof typeof GetUsersWithAnyOfPermissionsPermissionIdsItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersWithAnyOfPermissionsPermissionIdsItem = {
  'spz:control:view': 'spz:control:view',
  'spz:control-result:skip': 'spz:control-result:skip',
  'spz:control-result:start-investigation': 'spz:control-result:start-investigation',
  'spz:control-result:complete-investigation': 'spz:control-result:complete-investigation',
  'spz:control-result:manage-ownership': 'spz:control-result:manage-ownership',
  'spz:analysis-report:export': 'spz:analysis-report:export',
  'spz:control-result:change-priority': 'spz:control-result:change-priority',
} as const;
